import type { SearchForFacetValuesResponse } from '@algolia/client-search'
import { algoliaTemplatesIndex } from 'algolia/algolia-templates'
import { defaultSearchClient } from 'algolia/algolia'

function filterHits({ facetHits }: SearchForFacetValuesResponse) {
  const filteredHits = facetHits.filter(hit => !hit.value.includes('>'))
  return filteredHits.map(facet => ({
    label: facet.value,
    value: facet.value,
    isRefined: false,
    count: facet.count || 0,
  }))
}

export function searchForFacets(
  params: { facetName?: string; facetQuery?: string; query?: string; filters?: string } = {},
) {
  const facetName = params.facetName ?? 'category'
  const facetQuery = params.facetQuery ?? ''
  const searchParams = new URLSearchParams()
  if (params.query) {
    searchParams.set('query', params.query)
  }
  if (params.filters) {
    searchParams.set('filters', params.filters)
  }
  const paramsStr = searchParams.toString()

  return defaultSearchClient
    .searchForFacetValues({
      indexName: algoliaTemplatesIndex,
      facetName,
      searchForFacetValuesRequest: {
        facetQuery,
        maxFacetHits: 100,
        ...(paramsStr ? { params: paramsStr } : {}),
      },
    })
    .then(filterHits)
}
